/**
 * Zombie entity — chases humans, converts them on contact, and is stunned
 * (cannot move or convert) for the first 3 seconds of life (including after
 * a Human→Zombie conversion). Behaviour set (in run-order): collision,
 * chase-humans steer, boid-flow, zombie-flow, convert-human.
 *
 * The spawn-stun (`age < 3`) is enforced by `tick` returning before
 * `super.tick` — newly converted zombies don't immediately convert their
 * neighbours.
 *
 * @see Boid for the base class.
 */
import { CollisionBehavior } from '../behaviors/CollisionBehavior';
import { ConvertHumanBehavior } from '../behaviors/ConvertHumanBehavior';
import { FlowBehavior } from '../behaviors/FlowBehavior';
import { SteerLayerBehavior } from '../behaviors/SteerLayerBehavior';
import { IGameTime } from '../GameClock';
import { Boid, IBoidOptions } from './Boid';

export class Zombie extends Boid {
  constructor(options: IBoidOptions) {
    super(options);

    this.layer = this.options.world.layerByName('zombie');
    this.color.rgb = [0, 1, 0]; // zed are green
    this.behaviors.set('CollisionBehavior', new CollisionBehavior(this, 1, {
      iterations: 1,
      margin: 2,
      layerMask: this.World.layerByName('zombie'),
      predictive: true
    }));
    this.behaviors.set('ChaseHumans', new SteerLayerBehavior(this, 100, {
        layerName: 'human',
        radius: this.options.grid.cellSize * 3,
        nearest: true,
        breakingDistance: 0,
        breakingPower: 5
      })
    );
    this.behaviors.set('BoidFlow', new FlowBehavior(this, 1, {
        flowGrid: this.World.flowGrid,
        layer: this.World.layerByName('boid') // | options.world.layerByName('human')
      })
    );
    // this.behaviors.set('HumanFlow', new FlowBehavior(this, 1, {
    //     flowGrid: this.options.world.flowGrid, layer: options.world.layerByName('human')
    //   })
    // );

    this.behaviors.set('ZombieFlow', new FlowBehavior(this, 2, {
        flowGrid: this.options.world.flowGrid, layer: options.world.layerByName('zombie')
      })
    );

    this.behaviors.set('ConvertHumanBehavior', new ConvertHumanBehavior(this, 1, {margin: 1, minAgeBeforeConvert: 3}));
    this.World.zombies.add(this);
  }

  override tick(gameTime: IGameTime): void {
    if (this.age < 3 && gameTime.currentFrame !== 0) {
      this.age += gameTime.deltaTime;
      return;
    }
    super.tick(gameTime);
  }

  override die() {
    super.die();
    this.World.zombies.delete(this);
  }
}
